import React from 'react';

export default function LoadingState({ message = 'Carregando dados...' }) {
  return <div className="admin-loading">{message}</div>;
}
